"use client";

import { c as _c } from "react/compiler-runtime";
import { CartButton } from "@/components/custom/Cart/CartButton";
import { NavigationMenu, NavigationMenuList } from "@/components/ui/navigation-menu";
import type { NavItemEntry } from "@/lib/contentful/navItem";
import { AccountMenu } from "./AccountMenu";
import { Logo } from "./Logo";
import { NavItem } from "./NavItem";
import { SearchTrigger } from "./Search/SearchTrigger";
interface Props {
  navItems: NavItemEntry[];
  isLoggedIn: boolean;
}
export function MainNavDesktop(t0) {
  const $ = _c(36);
  const {
    navItems,
    isLoggedIn
  } = t0;
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== navItems) {
    const leftItems = navItems.slice(0, 3);
    const rightItems = navItems.slice(3);
    t6 = "hidden w-full items-center px-8 py-3 xl:grid xl:grid-cols-[1fr_auto_1fr]";
    const t9 = leftItems.map(_temp);
    if ($[11] !== t9) {
      t7 = <div className="flex justify-end"><NavigationMenu viewport={false} aria-label="Primary navigation, left"><NavigationMenuList className="gap-0.5">{t9}</NavigationMenuList></NavigationMenu></div>;
      $[11] = t9;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <div className="px-4"><Logo /></div>;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    t5 = "flex items-center";
    T1 = NavigationMenu;
    t3 = false;
    t4 = "Primary navigation, right";
    T0 = NavigationMenuList;
    t1 = "gap-0.5";
    t2 = rightItems.map(_temp2);
    $[0] = navItems;
    $[1] = T0;
    $[2] = T1;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    T0 = $[1];
    T1 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
  }
  let t9;
  if ($[14] !== T0 || $[15] !== t1 || $[16] !== t2) {
    t9 = <T0 className={t1}>{t2}</T0>;
    $[14] = T0;
    $[15] = t1;
    $[16] = t2;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== T1 || $[19] !== t3 || $[20] !== t4 || $[21] !== t9) {
    t10 = <T1 viewport={t3} aria-label={t4}>{t9}</T1>;
    $[18] = T1;
    $[19] = t3;
    $[20] = t4;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <SearchTrigger />;
    t12 = <CartButton />;
    $[23] = t11;
    $[24] = t12;
  } else {
    t11 = $[23];
    t12 = $[24];
  }
  let t13;
  if ($[25] !== isLoggedIn) {
    t13 = <div className="ml-auto flex items-center gap-1">{t11}{t12}<AccountMenu isLoggedIn={isLoggedIn} /></div>;
    $[25] = isLoggedIn;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t10 || $[28] !== t13 || $[29] !== t5) {
    t14 = <div className={t5}>{t10}{t13}</div>;
    $[27] = t10;
    $[28] = t13;
    $[29] = t5;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t14 || $[32] !== t6 || $[33] !== t7 || $[34] !== t8) {
    t15 = <div className={t6}>{t7}{t8}{t14}</div>;
    $[31] = t14;
    $[32] = t6;
    $[33] = t7;
    $[34] = t8;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
}
function _temp2(item_0) {
  return <NavItem key={item_0.sys.id} item={item_0} />;
}
function _temp(item) {
  return <NavItem key={item.sys.id} item={item} />;
}